(function () {
  if (window.__nzQuickAddInit) return;
  window.__nzQuickAddInit = true;

  function moneyFormat(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    var fmt = (window.Shopify && Shopify.money_format) || (window.shop && window.shop.money_format) || '';
    if (fmt && fmt.indexOf('{{') >= 0) {
      try {
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
          if (key.indexOf('with_comma') >= 0) {
            return amount.replace('.', ',');
          }
          if (key.indexOf('no_decimals') >= 0) {
            return Math.round(cents / 100).toString();
          }
          return amount;
        });
      } catch (e) {
        return '₹' + amount;
      }
    }
    return '₹' + amount;
  }

  function refreshCartIconBubble() {
    return fetch('?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return;
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* best effort */ });
  }

  // ---------------- Cart-icon sync with Shopflo cart ----------------
  // Shopflo runs in a separate widget so when the user changes qty / removes / adds
  // inside the Shopflo drawer the page does not know. Poll /cart.js while the
  // drawer is open and refresh on focus / visibility — keeps the bubble in sync
  // without a full reload.
  var lastKnownItemCount = null;
  var pollHandle = null;

  function syncCartIconIfChanged() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        if (lastKnownItemCount === null) lastKnownItemCount = cart.item_count;
        if (cart.item_count !== lastKnownItemCount) {
          lastKnownItemCount = cart.item_count;
          return refreshCartIconBubble();
        }
      })
      .catch(function () { /* best effort */ });
  }

  function isShopfloOverlayOpen() {
    // Shopflo injects an iframe/overlay when its drawer or checkout opens.
    return !!document.querySelector(
      'iframe[src*="shopflo"], iframe[id*="shopflo"], iframe[class*="shopflo"], [class*="shopflo-drawer"], [id*="shopflo-drawer"]'
    );
  }

  function startPolling() {
    if (pollHandle) return;
    pollHandle = setInterval(function () {
      if (isShopfloOverlayOpen()) {
        syncCartIconIfChanged();
      } else {
        // Drawer closed — final sync, then stop until the next signal.
        syncCartIconIfChanged();
        stopPolling();
      }
    }, 1500);
  }

  function stopPolling() {
    if (pollHandle) {
      clearInterval(pollHandle);
      pollHandle = null;
    }
  }

  // Watch for the Shopflo overlay being added to the DOM (drawer/buy-now/checkout).
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      if (isShopfloOverlayOpen()) startPolling();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Sync when user returns to the tab or window.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncCartIconIfChanged();
  });
  window.addEventListener('focus', syncCartIconIfChanged);
  window.addEventListener('pageshow', syncCartIconIfChanged);

  // Generic event hooks in case Shopflo (or any integration) dispatches one.
  ['shopflo:cart:updated', 'shopflo:cart-updated', 'cart:updated', 'cart:change'].forEach(function (name) {
    document.addEventListener(name, syncCartIconIfChanged);
    window.addEventListener(name, syncCartIconIfChanged);
  });

  // Wrap handleFloCartBtn so opening the drawer also kicks off polling.
  function wireFloCartHook() {
    if (typeof window.handleFloCartBtn !== 'function' || window.__nzFloCartHooked) return false;
    var original = window.handleFloCartBtn;
    window.handleFloCartBtn = function () {
      try { return original.apply(this, arguments); }
      finally {
        startPolling();
        setTimeout(syncCartIconIfChanged, 600);
      }
    };
    window.__nzFloCartHooked = true;
    return true;
  }
  if (!wireFloCartHook()) {
    // Shopflo bundle is async — keep trying briefly.
    var attempts = 0;
    var hookInterval = setInterval(function () {
      attempts++;
      if (wireFloCartHook() || attempts > 40) clearInterval(hookInterval);
    }, 250);
  }

  function addToCart(variantId, quantity) {
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then(function (r) {
      return r.json().then(function (json) { return { ok: r.ok, json: json }; });
    });
  }

  function openShopfloCart() {
    if (typeof window.handleFloCartBtn === 'function') {
      window.handleFloCartBtn();
    } else {
      // Fallback while Shopflo loads — go to /cart
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  // ---------------- Single-variant direct add ----------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nz-quick-add-single]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    addToCart(variantId, 1)
      .then(function (res) {
        if (!res.ok) {
          console.error('Quick add failed', res.json);
          return;
        }
        return refreshCartIconBubble().then(openShopfloCart);
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      });
  });

  // ---------------- Multi-variant modal ----------------
  var overlay = null;
  var currentProduct = null;
  var selected = {}; // option name -> value
  var currentVariant = null;

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'nz-qa-overlay';
    overlay.innerHTML =
      '<div class="nz-qa-panel" role="dialog" aria-modal="true" aria-label="Quick add">' +
      '  <button type="button" class="nz-qa-close" aria-label="Close">×</button>' +
      '  <div class="nz-qa-head">' +
      '    <div class="nz-qa-thumb"></div>' +
      '    <div class="nz-qa-meta">' +
      '      <h3 class="nz-qa-title"></h3>' +
      '      <div class="nz-qa-price"></div>' +
      '    </div>' +
      '  </div>' +
      '  <div class="nz-qa-body"></div>' +
      '  <div class="nz-qa-section">' +
      '    <span class="nz-qa-label">Quantity</span>' +
      '    <div class="nz-qa-qty">' +
      '      <button type="button" data-nz-qa-step="-1" aria-label="Decrease">−</button>' +
      '      <input type="number" min="1" value="1" data-nz-qa-qty>' +
      '      <button type="button" data-nz-qa-step="1" aria-label="Increase">+</button>' +
      '    </div>' +
      '  </div>' +
      '  <button type="button" class="nz-qa-add" data-nz-qa-add>Add to cart</button>' +
      '  <p class="nz-qa-error" hidden></p>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    overlay.querySelector('.nz-qa-close').addEventListener('click', closeModal);
    overlay.querySelectorAll('[data-nz-qa-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-nz-qa-step'), 10);
        var input = overlay.querySelector('[data-nz-qa-qty]');
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
    overlay.querySelector('[data-nz-qa-add]').addEventListener('click', onAddFromModal);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) closeModal();
    });
    return overlay;
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    currentProduct = null;
    currentVariant = null;
    selected = {};
  }

  function setError(msg) {
    if (!overlay) return;
    var el = overlay.querySelector('.nz-qa-error');
    if (msg) {
      el.textContent = msg;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  // /products/{handle}.js can return options as either an array of strings ("Size")
  // or an array of objects ({ name: "Size", position: 1, values: [...] }). Normalize.
  function getOptionNames(product) {
    return (product.options || []).map(function (opt) {
      if (opt && typeof opt === 'object') return opt.name;
      return opt;
    });
  }

  function findVariant(product, sel) {
    var names = getOptionNames(product);
    return (product.variants || []).find(function (v) {
      return names.every(function (name, idx) {
        return v.options[idx] === sel[name];
      });
    }) || null;
  }

  function renderModal(product) {
    ensureOverlay();
    currentProduct = product;
    selected = {};
    var optionNames = getOptionNames(product);
    var firstAvailable = (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvailable) {
      optionNames.forEach(function (name, idx) { selected[name] = firstAvailable.options[idx]; });
    }

    var thumb = overlay.querySelector('.nz-qa-thumb');
    thumb.innerHTML = '';
    var imgUrl = product.featured_image || (product.images && product.images[0]) || '';
    if (imgUrl) {
      var img = document.createElement('img');
      img.src = imgUrl.indexOf('//') === 0 ? 'https:' + imgUrl : imgUrl;
      img.alt = product.title || '';
      thumb.appendChild(img);
    }

    overlay.querySelector('.nz-qa-title').textContent = product.title || '';

    var bodyEl = overlay.querySelector('.nz-qa-body');
    bodyEl.innerHTML = '';
    optionNames.forEach(function (name, optIdx) {
      var section = document.createElement('div');
      section.className = 'nz-qa-section';
      var label = document.createElement('span');
      label.className = 'nz-qa-label';
      label.textContent = name;
      var list = document.createElement('div');
      list.className = 'nz-qa-options';
      list.setAttribute('data-nz-qa-option', name);

      var values = [];
      (product.variants || []).forEach(function (v) {
        var val = v.options[optIdx];
        if (values.indexOf(val) === -1) values.push(val);
      });
      values.forEach(function (val) {
        // Value is "available" if at least one variant matching this value is in stock.
        var hasAvailable = (product.variants || []).some(function (v) {
          return v.options[optIdx] === val && v.available;
        });
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nz-qa-option';
        b.textContent = val;
        b.setAttribute('data-value', val);
        if (!hasAvailable) {
          b.setAttribute('disabled', '');
          b.setAttribute('aria-disabled', 'true');
        }
        b.addEventListener('click', function () {
          if (b.disabled) return;
          selected[name] = val;
          updateModal();
        });
        list.appendChild(b);
      });

      section.appendChild(label);
      section.appendChild(list);
      bodyEl.appendChild(section);
    });

    updateModal();
    setError('');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function updateModal() {
    if (!currentProduct || !overlay) return;

    overlay.querySelectorAll('[data-nz-qa-option]').forEach(function (group) {
      var opt = group.getAttribute('data-nz-qa-option');
      group.querySelectorAll('.nz-qa-option').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-value') === selected[opt]);
      });
    });

    currentVariant = findVariant(currentProduct, selected);
    var priceEl = overlay.querySelector('.nz-qa-price');
    var addBtn = overlay.querySelector('[data-nz-qa-add]');
    if (currentVariant) {
      var html = '<strong>' + moneyFormat(currentVariant.price) + '</strong>';
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        html += ' <s>' + moneyFormat(currentVariant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
      addBtn.disabled = !currentVariant.available;
      addBtn.textContent = currentVariant.available ? 'Add to cart' : 'Sold out';
    } else {
      priceEl.textContent = '';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    }
  }

  function onAddFromModal() {
    if (!currentVariant || !currentVariant.available) return;
    var addBtn = overlay.querySelector('[data-nz-qa-add]');
    var qty = parseInt(overlay.querySelector('[data-nz-qa-qty]').value, 10) || 1;

    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    setError('');

    addToCart(currentVariant.id, qty)
      .then(function (res) {
        if (!res.ok) {
          setError((res.json && (res.json.description || res.json.message)) || 'Could not add to cart.');
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
          return;
        }
        return refreshCartIconBubble().then(function () {
          closeModal();
          openShopfloCart();
        });
      })
      .catch(function (err) {
        console.error(err);
        setError('Network error. Please try again.');
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nz-quick-add-open]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (!product) return;
        if (!Array.isArray(product.variants)) return;
        if (product.variants.length === 1) {
          // Should not normally happen since liquid emits a single-variant button, but handle anyway.
          return addToCart(product.variants[0].id, 1).then(function (res) {
            if (!res.ok) return;
            return refreshCartIconBubble().then(openShopfloCart);
          });
        }
        renderModal(product);
      })
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();
